import { render, staticRenderFns } from "./TaxRollDelq.vue?vue&type=template&id=77370146&"
import script from "./TaxRollDelq.vue?vue&type=script&lang=js&"
export * from "./TaxRollDelq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports